<template lang="pug">
  page
    .flex-fill.d-flex.flex-column.justify-content-center
      .container-tight.py-6
        .text-center.mb-4
          img(src="@/assets/logo.png")
          h2.mt-5 Loging in...
        //- form.card.card-md(action="#" method="post" @submit.prevent="loginAction()")
        //-   //- input(name="_token" :value="csrf_token" type="hidden")
        //-   .card-body
        //-     h2.mb-5.text-center Login with KSUM Unique ID
        //-     .mb-3
        //-       label.form-label Email address
        //-       input.form-control(:class="errors.email?'is-invalid':''" name="email" type='email' placeholder='Enter email' autocomplete='off' v-model="form.email")
        //-       form_error(:errors="errors.email")
        //-     .mb-2
        //-       label.form-label
        //-         | Password
        //-         span.form-label-description
        //-           a(href="https://startups.startupmission.in/admin" target="_blank") I forgot password
              
        //-       input.form-control(:class="errors.password?'is-invalid':''" name="password" type='password' placeholder='Password' v-model="form.password")
        //-       form_error(:errors="errors.password")
        //-     .mb-2
        //-       label.form-check
        //-         input.form-check-input(type='checkbox' v-model="form.remember")
        //-         span.form-check-label Remember me on this device
        //-     .form-footer.text-center
        //-       loading_btn.btn-block(type='submit' :loading="sending") Sign in


</template>

<script>
import { mapState, mapActions } from 'vuex'
import loadingBtn from '@/components/loadingBtn';
import form_error from '@/components/formErrors';
import page from '@/components/page_blank';

export default {
  props: ['to'],
  components:{
     'loading_btn': loadingBtn,
     form_error,
      page
  },
  data(){
    return {
      form: {
        code: ""
      },
    }
  },
  computed: {
    ...mapState('api', ['errors','sending']),
  },
  methods:{
    ...mapActions('auth',['exchange_code'])
  },
  mounted(){
    
    this.form.code = this.$route.query.code;

    this.exchange_code(this);

  }
}
</script>